import { computed } from 'vue';
import type { IdSearch } from '@/components/ui/IdSearch';
import { AccountActions, FundingSourceActions } from '@/integrations/Immersve/auth/actions';
import { useAuthStore } from '@/stores/auth.store';

export const accountSearch: IdSearch = {
  name: 'account',
  title: 'Funding sources',
  subtitle: 'Funding sources of an account.',
  label: 'Account ID',
  read: (route) => route.query.account,
  to: (id) => ({ path: '/funding-sources', query: { account: id } }),
  clearPath: '/funding-sources',
};

export const fundingSourceSearch: IdSearch = {
  name: 'funding-source',
  title: 'Funding source',
  subtitle: 'A funding source and its balance.',
  label: 'Funding source ID',
  read: (route) => route.params.fundingSourceId,
  to: (id) => `/funding-sources/${encodeURIComponent(id)}`,
  clearPath: '/funding-sources',
};

// The searches the user may run, asked on any account as the pages do:
// amethyst lists an account's funding sources under account:read, and serves
// one under funding-source:read.
export function useFundingSourceSearches() {
  const authStore = useAuthStore();
  function holds(action: string): boolean {
    return authStore.user?.isAuthorised(action) ?? false;
  }
  return computed(() => [
    ...(holds(AccountActions.Read) ? [accountSearch] : []),
    ...(holds(FundingSourceActions.Read) ? [fundingSourceSearch] : []),
  ]);
}
